import React, { useEffect, useCallback, useState } from 'react';
import { Button } from '@mui/material';

interface TextToSpeechProps {
  text: string;
}

const TextToSpeech: React.FC<TextToSpeechProps> = ({ text }) => {
  const [firstRender, setFirstRender] = useState(true);

  const speakText = useCallback(() => {
    const msg = new SpeechSynthesisUtterance(text);
    msg.lang = 'zh-CN';
    console.log('Speaking:', text);
    window.speechSynthesis.speak(msg);
  }, [text]);

  useEffect(() => {
    if (!firstRender) {
      speakText();
    } else {
      setFirstRender(false);
    }
  }, [text, speakText, firstRender]);

  return <Button onClick={speakText}>聴く</Button>;
};

export default TextToSpeech;
